import { updateAccountFromServer } from 'shared/account.settings/redux/actions';
import { applyDeclineUpdateFirmwareVersion, applyDeviceUpdate, applyFiletransferUpdate, applyNewRFStatuses, applyResetThermometersResponse, applyTemperatureUpdate, customCommandSuccess, deviceAdded, deviceDeleted, setDeviceOnline, } from 'console/redux/devices/items/actions';
import { applyEmailConfirmed } from 'console/account/redux/action';
import { apply_debug_text_message } from 'console/shared/components/panels/terminal/redux/actions';
import { onZ3kCustomCommandFail, onZ3kCustomCommandFailReset, onZ3kCustomCommandSuccess, } from 'console/redux/z3k-custom-command/actions';
import { download_sx_config_progress, download_sx_config_response, upload_sx_config_progress, upload_sx_config_response, } from 'console/redux/sx-config/actions';
import { updateDeviceTreeFromServer } from 'console/redux/devices/tree/actions';
import { applyNewEvent } from 'console/redux/main-actions';
import { createGeozoneFromServer, deleteGeozonesFromServer, updateGeozonesFromOldProgram, updateGeozonesFromServer, } from 'entities/map.geozone/model/actions';
import { newPhotoFromServer } from 'entities/device.photos/model/get-photos-actions';
import { update_billing_state, yakassa_failure_pay, yakassa_success_pay, } from 'console/billing/redux/actions';
import { applyIOPorts, setIOValue } from 'console/redux/io-actions';
import { processNewData } from 'app/base-ui-ts';
import { removeBilledSim, removeForeignSim, update_billed_sim, update_foreign_sim, } from 'console/sim/redux/actions';
import { update_design_package } from 'console/billing/package-custom-design/redux/actions';
import { onZ3kTargetTempConfirmed } from 'console/redux/z3k-target-temp/action';
import { addIcon, updateUiSettingsBeforeDeleteIcon, } from 'features/account.settings/ui/icon-settings/reducer/reducer';
import { updateAccessSuggestions } from 'entities/device.acl.suggestion/model/slice';
import { updateAccessRequests } from 'entities/device.acl.request/model/slice';
import { progressUpdate } from 'shared/components/banners/update-io-extension/model/slice';
import { addAttachmentUrl, addLoginLink } from 'entities/support.chat/model/store';
import { updateIssue } from 'entities/support.chat/model/actions';
import { event_array_to_object } from 'shared/api/comet/utils';
import { updateUpdateVersion } from 'entities/user.update_app/model/slice';
function processOldEvents(events, device_id, dispatch) {
    if (!events) {
        return;
    }
    function on_event(event) {
        switch (event.event_name) {
            case 'CurrentECUError':
            case 'AS_CUR_ERR':
                dispatch(applyDeviceUpdate(device_id, {
                    current_ecu_errors: event?.current_ecu_errors,
                }));
                break;
            case 'SavedECUErrors':
            case 'AS_SAV_ERR':
                dispatch(applyDeviceUpdate(device_id, {
                    saved_ecu_errors: event?.saved_ecu_errors,
                }));
                break;
            case 'GuardOn':
            case 'GuardOff':
                dispatch(applyDeviceUpdate(device_id, {
                    last_guard_event: {
                        time: event.time,
                        event: event.event_name,
                    },
                }));
                break;
        }
    }
    for (const event_row of events) {
        on_event(event_array_to_object(event_row, device_id));
    }
}
export function createCometListeners(comet, dispatch) {
    comet.listen({
        event: 'new_event',
        callback: (msg) => dispatch(applyNewEvent(msg)),
    });
    comet.listen({
        event: 'new_data',
        callback: (msg) => {
            const device_id = msg.device_id;
            processOldEvents(msg?.events, device_id, dispatch);
            processNewData(msg, dispatch);
        },
    });
    comet.listen({
        event: 'upload',
        callback: (msg) => {
            // processNewData(msg, dispatch);
            if ('z3k_config' in msg) {
                dispatch({
                    type: 'SAVE_Z3K_SETTINGS__OK',
                    device_id: msg.device_id,
                    config: msg.z3k_config,
                });
            }
        },
    });
    comet.listen({
        event: 'account_updated',
        callback: ({ account }) => dispatch(updateAccountFromServer(account)),
    });
    comet.listen({
        event: 'created',
        callback: (msg) => {
            const { event, ...rest } = msg;
            dispatch(deviceAdded(rest));
        },
    });
    comet.listen({
        event: 'deleted',
        callback: ({ device_id }) => dispatch(deviceDeleted(device_id)),
    });
    comet.listen({
        event: 'updated',
        callback: (msg) => {
            const { device_id, event, request_code, ...rest } = msg;
            dispatch(applyDeviceUpdate(device_id, rest, request_code));
        },
    });
    comet.listen({
        event: 'online',
        callback: ({ device_id }) => dispatch(setDeviceOnline(device_id, true)),
    });
    comet.listen({
        event: 'offline',
        callback: ({ device_id }) => dispatch(setDeviceOnline(device_id, false)),
    });
    comet.listen({
        event: 'io_ports',
        callback: ({ ports }) => dispatch(applyIOPorts(ports)),
    });
    comet.listen({
        event: 'io_value_changed',
        callback: ({ port, device_id }) => dispatch(setIOValue(device_id, port.name, port.value)),
    });
    comet.listen({
        event: 'new_temperature',
        callback: ({ device_id, time, temperature }) => dispatch(applyTemperatureUpdate(device_id, time, temperature)),
    });
    comet.listen({
        event: 'new_rf_statuses',
        callback: ({ device_id, rf }) => dispatch(applyNewRFStatuses(device_id, rf)),
    });
    comet.listen({
        event: 'send_custom_command_response',
        callback: ({ device_id, command_id }) => dispatch(customCommandSuccess(device_id, command_id)),
    });
    comet.listen({
        event: 'filetransfer_update',
        callback: ({ device_id, transfer }) => dispatch(applyFiletransferUpdate(device_id, transfer)),
    });
    comet.listen({
        event: 'declined_firmware_update',
        callback: ({ device_id, declined_version }) => dispatch(applyDeclineUpdateFirmwareVersion(device_id, declined_version)),
    });
    comet.listen({
        event: 'email_confirmed',
        callback: () => dispatch(applyEmailConfirmed()),
    });
    comet.listen({
        event: 'debug_text_message',
        callback: ({ device_id, text }) => dispatch(apply_debug_text_message(device_id, text)),
    });
    comet.listen({
        event: 'access_suggestions_updated',
        callback: ({ access_suggestions }) => dispatch(updateAccessSuggestions(access_suggestions)),
    });
    comet.listen({
        event: 'access_requests_updated',
        callback: ({ access_requests }) => dispatch(updateAccessRequests(access_requests)),
    });
    comet.listen({
        event: 'ui_version_updated',
        callback: ({ version }) => dispatch(updateUpdateVersion(version)),
    });
    comet.listen({
        event: 'send_z3k_command_response',
        condition: { command_name: 'TargetTemperature' },
        callback: ({ device_id, object_id, request_time }) => dispatch(onZ3kTargetTempConfirmed(device_id, object_id, request_time)),
    });
    comet.listen({
        event: 'send_z3k_command_response',
        condition: { command_name: 'ChangeWebElementState' },
        callback: ({ device_id, object_id, request_time, ok, event }) => {
            if (ok) {
                dispatch(onZ3kCustomCommandSuccess(device_id, object_id, request_time));
            }
            else {
                const error_message = 'Произошла ошибка';
                dispatch(onZ3kCustomCommandFail(device_id, object_id, request_time, error_message));
                setTimeout(() => dispatch(onZ3kCustomCommandFailReset(device_id, object_id, request_time)), 0);
            }
        },
    });
    comet.listen({
        event: 'send_z3k_command_response',
        condition: { command_name: 'SelectHeatingModeForCircuit' },
        callback: ({ device_id, object_id, request_time, ok }) => {
            if (ok) {
                dispatch(onZ3kCustomCommandSuccess(device_id, object_id, request_time));
            }
            else {
                const error_message = 'Произошла ошибка';
                dispatch(onZ3kCustomCommandFail(device_id, object_id, request_time, error_message));
                setTimeout(() => dispatch(onZ3kCustomCommandFailReset(device_id, object_id, request_time)), 0);
            }
        },
    });
    comet.listen({
        event: 'send_z3k_command_response',
        condition: { command_name: 'SelectHeatingMode' },
        callback: ({ device_id, object_id, request_time, ok }) => {
            if (ok) {
                // Backend debounces state updates, so heating circuits' states will be delayed by 1 second
                // We applying the same delay to minimize visual glitch
                setTimeout(() => dispatch(onZ3kCustomCommandSuccess(device_id, object_id, request_time)), 1e3);
            }
            else {
                const error_message = 'Произошла ошибка';
                dispatch(onZ3kCustomCommandFail(device_id, object_id, request_time, error_message));
                setTimeout(() => dispatch(onZ3kCustomCommandFailReset(device_id, object_id, request_time)), 0);
            }
        },
    });
    comet.listen({
        event: 'send_z3k_command_response',
        condition: { command_name: 'TargetTemperature' },
        callback: ({ device_id, object_id, request_time }) => dispatch(onZ3kTargetTempConfirmed(device_id, object_id, request_time)),
    });
    comet.listen({
        event: 'sx_download_config_progress',
        callback: ({ device_id, percent }) => dispatch(download_sx_config_progress(device_id, percent)),
    });
    comet.listen({
        event: 'sx_upload_config_progress',
        callback: ({ device_id, percent }) => dispatch(upload_sx_config_progress(device_id, percent)),
    });
    comet.listen({
        event: 'sx_download_config_response',
        callback: ({ device_id, ok, config }) => dispatch(download_sx_config_response(device_id, ok, config)),
    });
    comet.listen({
        event: 'sx_upload_config_response',
        callback: ({ device_id, ok }) => dispatch(upload_sx_config_response(device_id, ok)),
    });
    comet.listen({
        event: 'reset_thermometers_response',
        callback: ({ device_id }) => dispatch(applyResetThermometersResponse(device_id)),
    });
    comet.listen({
        event: 'device_tree_updated',
        callback: ({ device_tree, device_tree_update_time }) => dispatch(updateDeviceTreeFromServer(device_tree, device_tree_update_time)),
    });
    comet.listen({
        event: 'geozone_created',
        callback: ({ added_geozone }) => dispatch(createGeozoneFromServer(added_geozone)),
    });
    comet.listen({
        event: 'geozones_deleted',
        callback: ({ geozone_id }) => dispatch(deleteGeozonesFromServer(geozone_id)),
    });
    comet.listen({
        event: 'delete_icons_id',
        callback: ({ delete_icons_id }) => {
            dispatch(updateUiSettingsBeforeDeleteIcon(delete_icons_id));
        },
    });
    comet.listen({
        event: 'new_icon_id_uploaded',
        callback: (add_icons) => {
            dispatch(addIcon(add_icons));
        },
    });
    comet.listen({
        event: 'geozones_updated',
        callback: ({ updated_geozones }) => dispatch(updateGeozonesFromServer(updated_geozones)),
    });
    comet.listen({
        event: 'geozones_updated_from_old_program',
        callback: ({ all_geozones }) => dispatch(updateGeozonesFromOldProgram(all_geozones)),
    });
    comet.listen({
        event: 'camerashot_ready',
        callback: ({ device_id, unixtime, filename }) => dispatch(newPhotoFromServer(device_id, unixtime, filename)),
    });
    comet.listen({
        event: 'billing_state_updated',
        callback: ({ billing_state }) => dispatch(update_billing_state(billing_state)),
    });
    comet.listen({
        event: 'yakassa_success_pay',
        callback: (data) => dispatch(yakassa_success_pay(data)),
    });
    comet.listen({
        event: 'yakassa_canceled_pay',
        callback: () => dispatch(yakassa_failure_pay()),
    });
    comet.listen({
        event: 'foreign_sim_removed',
        callback: ({ msisdn }) => dispatch(removeForeignSim(msisdn)),
    });
    comet.listen({
        event: 'billed_sim_removed',
        callback: ({ msisdn }) => dispatch(removeBilledSim(msisdn)),
    });
    comet.listen({
        event: 'foreign_sim_updated',
        callback: ({ foreign_sim }) => dispatch(update_foreign_sim(foreign_sim)),
    });
    comet.listen({
        event: 'billed_sim_updated',
        callback: ({ billed_sim }) => dispatch(update_billed_sim(billed_sim)),
    });
    comet.listen({
        event: 'design_package_updated',
        callback: ({ allow_design_package }) => dispatch(update_design_package(allow_design_package)),
    });
    comet.listen({
        event: 'update_firmware_external_devices',
        callback: ({ update_firmware_external_devices_state, device_id }) => {
            dispatch(progressUpdate({ device_id, ...update_firmware_external_devices_state }));
        },
    });
    comet.listen({
        event: 'update_support_issue',
        callback: ({ issue }) => dispatch(updateIssue(issue)),
    });
    comet.listen({
        event: 'update_okdesk_attachment_url',
        callback: (msg) => dispatch(addAttachmentUrl(msg)),
    });
    comet.listen({
        event: 'update_okdesk_login_url',
        callback: ({ url }) => dispatch(addLoginLink(url)),
    });
    comet.listen({
        event: 'send_z3k_command_response',
        condition: { command_name: 'RunScenario' },
        callback: ({ device_id, object_id, request_time, ok }) => {
            if (ok) {
                // Backend debounces state updates, so heating circuits' states will be delayed by 1 second
                // We applying the same delay to minimize visual glitch
                setTimeout(() => dispatch(onZ3kCustomCommandSuccess(device_id, object_id, request_time)), 1e3);
            }
            else {
                const error_message = 'Произошла ошибка';
                dispatch(onZ3kCustomCommandFail(device_id, object_id, request_time, error_message));
                setTimeout(() => dispatch(onZ3kCustomCommandFailReset(device_id, object_id, request_time)), 0);
            }
        },
    });
    comet.listen({
        event: 'finish_z3k_config_write',
        callback: (message) => {
            dispatch({ type: 'CONFIG_END_WRITE', device_id: message.device_id });
        },
    });
}
